// AppRoutes.js - Updated with MyOrdersPage import

import React from 'react';
import { Routes, Route, Navigate, Router } from 'react-router-dom';

// Layout Components
import MainLayout from '../components/layout/MainLayout';
import DashboardLayout from '../components/layout/DashboardLayout';

// Public Pages
import LandingPage from '../pages/public/Landing/LandingPage';
import LoginPage from '../pages/public/Login';
import SignupPage from '../pages/public/Signup/SignupPage';

// Dashboard Pages
import BuyerDashboard from '../pages/dashboard/buyer/Dashboard';
import SellerDashboard from '../pages/dashboard/seller/Dashboard';
import AdminDashboard from '../pages/dashboard/admin/Dashboard';

// Profile Pages
import BuyerProfile from '../features/buyer/profile/BuyerProfile';
import SellerProfile from '../features/seller/profile/SellerProfile';
import AdminProfile from '../features/admin/profile/AdminProfile';

// Feature Pages
import ProductsPage from '../features/buyer/products/ProductsPage';
import QuotationsPage from '../features/buyer/quotations/QuotationsPage';
import ProductDetailsPage from '../features/buyer/products/components/ProductDetailsPage/ProductDetailsPage';

// ADD THIS IMPORT - My Orders Page
import MyOrdersPage from '../features/buyer/orders/MyOrdersPage';

// Seller Product Pages
import MyProducts from '../features/seller/MyProduct/MyProducts';
import AddProductPage from '../features/seller/MyProduct/AddProductPage/AddProductPage';
import ViewProductPage from '../features/seller/MyProduct/ViewProductPage/ViewProductPage';
import EditProductPage from '../features/seller/MyProduct/EditProductPage/EditProductPage';

// Seller Sales Pages
import SalesPage from '../features/seller/sales/SalesPage';
import AddProductDetails from '../features/seller/sales/AddProductDetails/AddProductDetails';
import BulkUpload from '../features/seller/sales/BulkUpload/BulkUpload';
import ProductTemplates from '../features/seller/sales/ProductTemplates/ProductTemplates';

// Admin Pages
import UsersPage from "../pages/dashboard/admin/UsersPage";
import MessagesPage from '../pages/dashboard/admin/AdminChatPanel';
import ProductsPages from '../pages/dashboard/admin/ProductsPage';
import ProductDetailPage from '../pages/dashboard/admin/admin/ProductDetailPage';
import AdminOrdersPage from '../pages/dashboard/admin/Orderpage'

// Chat Pages
import ChatPage from '../features/ChatPage';
import ChatList from '../features/ChatList';
import BuyerChats from '../features/buyer/BuyerChats';
import SellerChats from '../features/seller/SellerChats';

import ProtectedRoute from './ProtectedRoute';
import ForgotPassword from '../pages/public/Forgotpassword/Forgotpassword';

import ScrollToTop from '../components/ScrollToTop';
import CartPage from '../features/buyer/CartPage/CartPage';

const AppRoutes = () => {
  return (
<>
    <ScrollToTop />
    <Routes>
      {/* Public Routes with MainLayout */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Route>

      {/* Buyer Protected Routes with DashboardLayout */}
      <Route
        path="/buyer"
        element={
          <ProtectedRoute allowedRoles={['buyer']}>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<BuyerDashboard />} />

        {/* Buyer Profile */}
        <Route path="profile" element={<BuyerProfile />} />

        {/* Buyer Products */}
        <Route path="products">
          <Route index element={<ProductsPage />} />
          <Route path=":id" element={<ProductDetailsPage />} />
        </Route>

        {/* Buyer Quotations */}
        <Route path="quotations" element={<QuotationsPage />} />

        {/* Buyer Chat */}
        <Route path="chats">
          <Route index element={<BuyerChats />} />
          <Route path=":chatId" element={<ChatPage />} />
        </Route>

        {/* UPDATED THIS LINE: Replace the dummy orders page with MyOrdersPage */}
        <Route path="orders" element={<MyOrdersPage />} />
        
        {/* Other Buyer Routes */}
        <Route path="favorites" element={<div>Favorites Page</div>} />
        <Route path="analytics" element={<div>Analytics Page</div>} />
        <Route path="messages" element={<div>Messages Page</div>} />
        <Route path="settings" element={<div>Settings Page</div>} />
        <Route path="cart" element={<CartPage />} />

      </Route>

      {/* Seller Protected Routes with DashboardLayout */}
      <Route
        path="/seller"
        element={
          <ProtectedRoute allowedRoles={['seller']}>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<SellerDashboard />} />

        {/* Seller Profile */}
        <Route path="profile" element={<SellerProfile />} />

        {/* Seller Products Management */}
        <Route path="myproducts">
          <Route index element={<MyProducts />} />
          <Route path="add" element={<AddProductPage />} />
          <Route path=":id" element={<ViewProductPage />} />
          <Route path=":id/edit" element={<EditProductPage />} />
        </Route>

        {/* Seller Sales */}
        <Route path="sales">
          <Route index element={<SalesPage />} />
          <Route path="add-product" element={<AddProductDetails />} />
          <Route path="bulk-upload" element={<BulkUpload />} />
          <Route path="templates" element={<ProductTemplates />} />
        </Route>

        {/* Seller Chat */}
        <Route path="chats">
          <Route index element={<SellerChats />} />
          <Route path=":chatId" element={<ChatPage />} />
        </Route>

        {/* Other Seller Routes */}
        <Route path="quotations" element={<div>Seller Quotations</div>} />
        <Route path="orders" element={<div>Seller Orders</div>} />
        <Route path="analytics" element={<div>Seller Analytics</div>} />
        <Route path="messages" element={<div>Messages</div>} />
        <Route path="settings" element={<div>Settings</div>} />
      </Route>

      {/* Admin Protected Routes with DashboardLayout */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute allowedRoles={['admin']}>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />

        {/* Admin Profile */}
        <Route path="profile" element={<AdminProfile />} />

        {/* Admin Management Pages */}
        <Route path="users" element={<UsersPage />} />
        <Route path="products">
          <Route index element={<ProductsPages />} />
          <Route path=":id" element={<ProductDetailPage />} />
        </Route>
        <Route path="chats" element={<MessagesPage />} />
       <Route path="orders" element={<AdminOrdersPage />} />


        {/* Admin Chat Access */}
        <Route path="chats/:chatId" element={<ChatPage />} />

        {/* Other Admin Routes */}
        <Route path="quotations" element={<div>Admin Quotations</div>} />
        <Route path="orders" element={<div>Admin Orders</div>} />
        <Route path="reports" element={<div>Admin Reports</div>} />
        <Route path="settings" element={<div>Settings</div>} />
      </Route>

      {/* Common Protected Routes */}
      
      {/* Shared Chat Routes for quick access */}
      <Route
        path="/chat/:chatId"
        element={
          <ProtectedRoute allowedRoles={['buyer', 'seller', 'admin']}>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<ChatPage />} />
      </Route>

      <Route
        path="/chats"
        element={
          <ProtectedRoute allowedRoles={['buyer', 'seller', 'admin']}>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<ChatList />} />
      </Route>

      <Route
        path="/messages"
        element={
          <ProtectedRoute allowedRoles={['buyer', 'seller', 'admin']}>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<div>Messages Page</div>} />
      </Route>

      <Route
        path="/settings"
        element={
          <ProtectedRoute allowedRoles={['buyer', 'seller', 'admin']}>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<div>Settings Page</div>} />
      </Route>

      {/* 404 Page - Redirect to Home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
};

export default AppRoutes;